import styled from "styled-components";

export const Container = styled.div`
    text-align: center;
    margin: ${props => props.theme.spacing};
    @media (max-width: 767px){
        margin: 0 18px 30px;
    }
`;

export const Link = styled.a`
    height: 40px;
    background-color: #070808;
    color: #FFFFFF;
    font-family: Mallory;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 1px;
    line-height: 40px;
    text-align: center;
    display: inline-block;
    text-decoration: none;
    border: 1px solid rgb(7,8,8);
    margin: auto;
    padding: 0 40px;
    &:hover {
        background-color: rgb(255,255,255);
        color: rgb(7,8,8);
        border: 1px solid rgb(7,8,8);
    }
`;